var map = {
	"./categories_engagement_mobile_all.webp": 1691,
	"./categories_engagement_mobile_all@2x.webp": 1666,
	"./categories_memoire_mobile_all.webp": 1692,
	"./categories_memoire_mobile_all@2x.webp": 1667,
	"./color_gold_a-2230-1.webp": 1760,
	"./color_gold_a-2230-1@2x.webp": 1706,
	"./color_multicolor_a-1629-3.webp": 1761,
	"./color_multicolor_a-1629-3@2x.webp": 1707,
	"./color_platinum_a-2130-1.webp": 1762,
	"./color_platinum_a-2130-1@2x.webp": 1708,
	"./color_redgold_a-2111-1.webp": 1763,
	"./color_redgold_a-2111-1@2x.webp": 1709,
	"./color_rosegold_a-1755-1.webp": 1764,
	"./color_rosegold_a-1755-1@2x.webp": 1710,
	"./color_signature_a-1598-6.webp": 1765,
	"./color_signature_a-1598-6@2x.webp": 1711,
	"./color_whitegold_a-1939-8.webp": 1766,
	"./color_whitegold_a-1939-8@2x.webp": 1712,
	"./customer_design_1.webp": 1767,
	"./customer_design_10.webp": 1768,
	"./customer_design_10@2x.webp": 1713,
	"./customer_design_1@2x.webp": 1714,
	"./customer_design_2.webp": 1769,
	"./customer_design_2@2x.webp": 1715,
	"./customer_design_3.webp": 1770,
	"./customer_design_3@2x.webp": 1716,
	"./customer_design_4.webp": 1771,
	"./customer_design_4@2x.webp": 1717,
	"./customer_design_5.webp": 1772,
	"./customer_design_5@2x.webp": 1718,
	"./customer_design_6.webp": 1773,
	"./customer_design_6@2x.webp": 1719,
	"./customer_design_7.webp": 1774,
	"./customer_design_7@2x.webp": 1720,
	"./customer_design_8.webp": 1775,
	"./customer_design_8@2x.webp": 1721,
	"./customer_design_9.webp": 1776,
	"./customer_design_9@2x.webp": 1722,
	"./endless_possibilities.webp": 1777,
	"./endless_possibilities@2x.webp": 378,
	"./impressive_jewelry.webp": 1693,
	"./impressive_jewelry@2x.webp": 1668,
	"./individual_weddingrings.webp": 1778,
	"./individual_weddingrings@2x.webp": 377,
	"./individual_weddingrings_ring.webp": 1779,
	"./individual_weddingrings_ring@2x.webp": 1723,
	"./individual_weddingrings_ring_1.webp": 1780,
	"./individual_weddingrings_ring_1@2x.webp": 1724,
	"./individual_weddingrings_ring_2.webp": 1781,
	"./individual_weddingrings_ring_2@2x.webp": 1725,
	"./individual_weddingrings_ring_3.webp": 1782,
	"./individual_weddingrings_ring_3@2x.webp": 1726,
	"./individual_weddingrings_ring_4.webp": 1783,
	"./individual_weddingrings_ring_4@2x.webp": 1727,
	"./individual_weddingrings_ring_5.webp": 1784,
	"./individual_weddingrings_ring_5@2x.webp": 1728,
	"./individual_weddingrings_spread.webp": 1785,
	"./individual_weddingrings_spread@2x.webp": 1729,
	"./information_ethical.webp": 1694,
	"./information_ethical@2x.webp": 1669,
	"./information_ethical_mob.webp": 1695,
	"./information_ethical_mob@2x.webp": 1670,
	"./information_inspiring_design.webp": 1696,
	"./information_inspiring_design@2x.webp": 1671,
	"./information_inspiring_design_mob.webp": 1697,
	"./information_inspiring_design_mob@2x.webp": 1672,
	"./information_message_of_love.webp": 1698,
	"./information_message_of_love@2x.webp": 1673,
	"./information_message_of_love_mob.webp": 1699,
	"./information_message_of_love_mob@2x.webp": 1674,
	"./inspiration_01.webp": 1730,
	"./inspiration_01@2x.webp": 1679,
	"./inspiration_02.webp": 1731,
	"./inspiration_02@2x.webp": 1680,
	"./inspiration_03.webp": 1732,
	"./inspiration_03@2x.webp": 1681,
	"./inspiration_04.webp": 1733,
	"./inspiration_04@2x.webp": 1682,
	"./inspiration_05.webp": 1734,
	"./inspiration_05@2x.webp": 1683,
	"./inspiration_06.webp": 1735,
	"./inspiration_06@2x.webp": 1684,
	"./inspiration_collections.webp": 1675,
	"./inspiration_collections@2x.webp": 1665,
	"./inspiration_styles.webp": 1700,
	"./inspiration_styles@2x.webp": 1664,
	"./inspiring_background.webp": 1786,
	"./inspiring_background@2x.webp": 1736,
	"./inspiring_background_mobile.webp": 1787,
	"./inspiring_background_mobile@2x.webp": 1737,
	"./inspiring_background_parallax.webp": 1788,
	"./inspiring_background_parallax@2x.webp": 1738,
	"./magazine.webp": 1789,
	"./magazine@2x.webp": 1739,
	"./ring_a-2097.webp": 1701,
	"./ring_a-2097@2x.webp": 1676,
	"./ring_memoires.webp": 1702,
	"./ring_memoires@2x.webp": 1677,
	"./signature_background_desktop.webp": 412,
	"./signature_background_desktop@2x.webp": 1740,
	"./signature_background_mobile.webp": 411,
	"./signature_background_mobile@2x.webp": 1741,
	"./world_of_acredo.webp": 1790,
	"./world_of_acredo@2x.webp": 1742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1750;